(function ($) {
  if ($('body.woocommerce-cart').length > 0) {
    // Overlay and Add kid form elements
    const $overlay = $('.form-overlay');
    const $addKid = $('.form-ajouter-enfant');

    // Cart page
    // When a user changes the children for a product in cart, update cart via ajax (See inc/woocommerce.php for backend hook prefix_update_cart_notes)
    function updateChildrenInCartItem() {
      $('.prefix-cart-children').on('change', function () {
        $('.cart_totals').block({
          message: null,
          overlayCSS: {
            background: '#fff',
            opacity: 0.6,
          },
        });
        var cart_id = $(this).data('cart-id'),
          $cartButton = $('.wc-proceed-to-checkout .cart-fixed-atc');
        const currentValue = $(this).val();
        $.ajax({
          type: 'POST',
          url: global_vars.ajaxurl,
          data: {
            action: 'prefix_update_cart_notes',
            security: $('#woocommerce-cart-nonce').val(),
            selectedChild: currentValue,
            cart_id: cart_id,
          },
          success: function (response) {
            // Force Woocommerce to refresh fragments (mini cart)
            $(document.body).trigger('wc_fragment_refresh');
            $('.cart_totals').unblock();
            response.isCartValid
              ? $cartButton.removeClass('disabled')
              : $cartButton.addClass('disabled');
          },
          error: function (xhr, status, error) {
            // console.log(error);
            $('.cart_totals').unblock();
          },
        });
      });
    }

    function initSelect2() {
      if ($.isFunction($.fn.select2)) {
        const $selectElement = $('.prefix-cart-children');

        $selectElement.each(function () {
          let currentValue = $(this).val();
          const $select2Object = $(this).select2({
            theme: 'bootstrap-5',
            minimumResultsForSearch: Infinity,
            placeholder: 'Sélectionner un enfant',
          });
          $(this).on('select2:select', function (e) {
            const selectedValue = $(e.currentTarget).val();
            if (selectedValue === 'add-button') {
              // If user clicked add-button element (Last element of dropdown)
              // Force select the previous value selected and show add kid popup form
              $select2Object.val(currentValue).trigger('change');
              showAddKidForm();
            } else {
              currentValue = selectedValue;
            }
          });
        });
      }
    }

    function bindPictureUploader() {
      $('.pic-uploader input').change(function () {
        readURL(this);
      });
    }

    // Load the image uploaded in Add kid form through FileReader library
    function readURL(input) {
      if (input.files && input.files[0]) {
        const reader = new FileReader();

        reader.onload = function (e) {
          const uploadedImage = reader.result;
          $('#photo-enfant')
            .css('backgroundImage', `url(${uploadedImage})`)
            .width(80)
            .height(80);
        };

        reader.readAsDataURL(input.files[0]);
      }
    }

    // Bind close buttons that are on add kid form and in the success message block.
    // Hides page overlay when closing the fixed pop-in.
    function bindAddKidCloseButton() {
      const $addKidForm = $('.form-ajouter-enfant, #message.updated');
      if ($addKidForm.length > 0) {
        const $closeButton = $addKidForm.find('.close-action');
        $closeButton.click(function () {
          $addKidForm.hide();
          $overlay.hide();
        });
      }
    }

    // Woocommerce cart item name hook places Add kid button before variation
    // We need to move it after variations
    function repositionAddKidButtons() {
      const $addKidButtons = $('.btn-add-kid');
      if ($addKidButtons.length > 0) {
        $addKidButtons.each(function () {
          $(this).appendTo($(this).parent());
        });
      }
    }

    function bindAddKidButtons() {
      const $addKidButtons = $('.product-add-kid');
      if ($addKidButtons.length > 0) {
        $addKidButtons.click(function () {
          showAddKidForm();
        });
      }
    }

    function showAddKidForm() {
      $overlay.show();
      $addKid.show();
    }

    initSelect2();
    bindAddKidCloseButton();
    bindPictureUploader();
    repositionAddKidButtons();
    bindAddKidButtons();
    updateChildrenInCartItem();

    $('body').on('updated_cart_totals', function () {
      // When end users delete a product,
      // "Select child" dropdown switches back to normal dropdown and not a select2 one.
      // We need to re-initiate Select2 and reposition it
      initSelect2();
      repositionAddKidButtons();
      updateChildrenInCartItem();
    });
  }
})(jQuery);
